import Minus from '../../src/legacy/Minus';
export default Minus;
